import i18n from '@/i18n';
export default [
    {
        get text() { return i18n?.global?.t('tableHeaders.id')},
        value: 'id',
        sortable: true,
    },
    { get text() { return i18n?.global?.t('tableHeaders.name')}, value: 'name' },
    { get text() { return i18n?.global?.t('tableHeaders.type')}, value: 'type' },
    { get text() { return i18n?.global?.t('tableHeaders.group')}, value: 'item_group' },

    {
        get text() { return i18n?.global?.t('tableHeaders.designation')},
        value: 'designation',
    },
    { get text() { return i18n?.global?.t('tableHeaders.symbol')}, value: 'symbol' },
    {
        get text() { return i18n?.global?.t('tableHeaders.serialNumber')},
        value: 'serial_no',
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.registryNumber')},
        value: 'registry_no',
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.openIssues')},
        value: 'open_issues_count',
    },
    // {
    //     get text() { return i18n?.global?.t('tableHeaders.udtNumber'),
    //     value: 'superv_office_no',
    // },
    // {
    //     get text() { return i18n?.global?.t('tableHeaders.manufacturedYear'),
    //     value: 'manufactured_year',
    // },
    { get text() { return i18n?.global?.t('common.takenBy')}, value: 'taken_by_user' }, //TODO
    {
        get text() { return i18n?.global?.t('common.toolIssuedBy')},
        value: 'issued_by_user',
    }, //TODO
    {
        get text() { return i18n?.global?.t('common.predictedReturnDate')},
        value: 'predicted_return_at',
    }, //TODO
    { value: 'operation', width: 54, fixed: true },
]